import type { StoryCtx } from './ctx.js';
import type { StoryNode } from './types.js';

/*
 * Die Szene ist das einzige Objekt der Handlung (PLAN.md A77, §13). Ihre Art ist ihre Form: Zeitpunkt (`event`, auf der Fläche als
 * Marke, „Ereignis“) oder Zeitraum (`period`, als Balken, „Zeitraum“). Sie hat zwei voneinander unabhängige Orte:
 *  - auf der Fläche (Baum, `parentId`): am Zeitstrahl angedockt (`at` bzw. `from`/`to`), lose auf einer Fläche (`x`/`y`) oder unter dem
 *    Manuskript – dann ist sie nicht auf der Fläche;
 *  - im Manuskript: `chapterId` (null = nicht eingeordnet) und `rank` (Stelle im Kapitel).
 */

export const SCENE_KINDS = ['event', 'period'] as const;
export type SceneKind = (typeof SCENE_KINDS)[number];

/** Ist der Node eine Szene (Zeitpunkt oder Zeitraum)? */
export const isScene = (n: Pick<StoryNode, 'kind'> | null | undefined): boolean => !!n && (n.kind === 'event' || n.kind === 'period');

/** Liegt die Szene auf der Fläche (angedockt oder lose)? Nicht, wenn sie unter dem Manuskript liegt. */
export const isOnCanvas = (ctx: StoryCtx, n: StoryNode): boolean => isScene(n) && !!n.parentId && ctx.nodes.get(n.parentId)?.kind !== 'manuscript';

/** Alle Szenen der Geschichte. */
export const scenesOf = (ctx: StoryCtx): StoryNode[] => ctx.story.nodes.filter(isScene);
